Whether the querying partner has been approved to self-service their live SEEK API client credentials.

SEEK will approve partners once they have demonstrated progress through the development process.
When true, administrative users will be able to issue and rotate client credentials in the Developer Dashboard.
